<template>
  <section class="hr-section hr-dirs" aria-labelledby="hr-dirs-title">
    <div class="hr-container">
      <h2 id="hr-dirs-title" class="hr-section-title hr-section-title--center">Основные направления</h2>
      <div class="hr-dirs__grid">
        <article
          v-for="item in items"
          :key="item.title"
          class="hr-dir"
          :class="{ 'hr-dir--flip': !item.imageLeft }"
        >
          <div class="hr-dir__media">
            <img :src="item.image" :alt="item.imageAlt" />
          </div>
          <div class="hr-dir__body">
            <h3 class="hr-dir__title">{{ item.title }}</h3>
            <p class="hr-dir__desc">{{ item.description }}</p>
            <ul class="hr-dir__points">
              <li v-for="point in item.points" :key="point">
                <HrIcon name="check" />
                <span>{{ point }}</span>
              </li>
            </ul>
            <router-link class="hr-dir__more" :to="item.moreTo">Подробнее →</router-link>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from './HrIcon.vue'

export default {
  name: 'HrDirections',
  components: { HrIcon },
  props: {
    items: { type: Array, required: true },
  },
}
</script>
